import { observable, action, flow, computed } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './StoreCardMsgServ';

class StoreCardMsgMod {
  // 民族列表、银行总行列表、支行列表、支行模糊搜索关键字
  @observable nationList = [];

  @observable headBankList = [];

  @observable cardCode = '';

  @observable password = '';

  @observable phone = '';

  // 用户的userId
  @observable userId = '';

  // 初始化健康顾问、健康顾问、健康顾问编号、健康顾问姓名、销售顾问编号、销售顾问姓名、本人真实姓名。（健康顾问姓名为null代表未查是否有此人，为''时代表查无此人，为其它时，代表其名字， saleName同理）。
  @observable initHealthy = '';

  @observable healthy = '';

  @observable healthyName = null;

  @observable sale = '';

  @observable saleName = null;

  @observable realName = '';

  @observable healthyStatus = '';

  @observable saleStatus = '';

  // 证件类型，证件号，生日，性别，由于picker的value 要数组，为方便，凡是select的value，都用数组存储值，取第一项就好了
  @observable certType = 1;

  // @observable certNum = '';
  @observable certNum = '';

  @observable birth = '';

  @observable gender = '';

  // 文化程度，职业，民族
  @observable level = '';

  @observable job = '';

  @observable nation = '';

  // 银行地址选择、总行、支行、支行名、卡号
  @observable bankAddress = null;

  @observable headBankId = '';

  @observable branchBankId = '';

  @observable branchBankName = '';

  @observable bankNum = '';

  // 是否同意协议
  @observable isAgree = false;

  @observable noChange = false;

  //当前选中的店铺id
  @observable storeTypeId = '';

  //当前选中的店铺名称
  @observable storeTypeName = '';

  //区域代理选择的省市区
  agentProvinceCode = '';
  agentProvinceName = '';
  agentCityCode = '';
  agentCityName = '';
  agentCountyCode = '';
  agentCountyName = '';

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 初始化表单信息
   */
  @action
  initData() {
    const cardFillMsg = Util.getLocalCache(Config.localStorageKeys.member_cardFillMsg) || {};
    if (
      !cardFillMsg.phone ||
      cardFillMsg.phone != this.phone ||
      this.bankAddress ||
      this.headBankId ||
      this.branchBankId
    )
      return;
    const {
      businessName,
      businessAddress,
      detailAddress,
      password,
      sale,
      realName,
      certType,
      certNum,
      birth,
      gender,
      level,
      job,
      nation,
      bankNum,
      bankAddress,
      headBankId,
      branchBankId,
      branchBankName
    } = cardFillMsg;
    this.changeState({
      businessName,
      businessAddress,
      detailAddress,
      password,
      passwordAgain: password,
      sale,
      realName,
      certType,
      certNum,
      birth,
      gender,
      level,
      job,
      nation,
      bankAddress,
      headBankId,
      branchBankId,
      branchBankName,
      bankNum
    });
    if (sale) {
      this.getMemberName('saleName', sale);
    }
  }

  /**
   * 清除店铺填写的数据
   */
  @action
  clearStoreData() {
    this.nationList = [];
    this.headBankList = [];
    this.initHealthy = '';
    this.healthy = '';
    this.healthyName = null;
    this.sale = '';
    this.saleName = null;
    this.realName = '';
    this.certType = 1;
    this.certNum = '';
    this.birth = '1990-01-01';
    this.gender = '';
    this.level = '';
    this.job = '';
    this.nation = '';
    this.bankAddress = null;
    this.headBankId = '';
    this.branchBankId = '';
    this.branchBankName = '';
    this.bankNum = '';
    this.isAgree = false;
  }

  /**
   * 获取民族列表
   */
  getNationList = flow(function* (memberNum) {
    try {
      const { data } = yield Serv.getNationList({ cardCode: memberNum });
      if (Array.isArray(data)) {
        this.nationList = data.map((_val) => ({ label: _val.name, value: _val.id }));
      }
    } catch (error) {}
  });

  /**
   * 获取银行总行列表
   */
  getHeadBankList = flow(function* () {
    try {
      const { data } = yield Serv.getHeadBankList();
      if (Array.isArray(data)) {
        this.headBankList = data.map((_val) => ({
          label: _val.name,
          value: _val.id,
          name: _val.name
        }));
      }
    } catch (error) {}
  });

  /**
   * 获取用户姓名
   */
  // getMemberName = flow(function*(memberName, memberStatus, memberNum) {
  //   const { data, resultCode } = yield Serv.getMemberName({ cardCode: memberNum });
  //   if (resultCode == '0' && data) {
  //     this[memberName] = data.length > 5 ? data[0] + '...' + data[data.length - 1] : data;
  //     this[memberStatus] = data.status;
  //   }
  // });

  /**
   * 获取用户姓名
   * @param {String} memberName - healthyName健康顾问，saleName销售顾问
   * @param {String} memberNum - 用户卡号
   */
  getMemberName = flow(function* (memberName, memberNum) {
    const { data, resultCode } = yield Serv.getMemberInfo({ cardCode: memberNum });
    if (resultCode == '0' && data) {
      this[memberName] =
        data.realName.length > 5
          ? data.realName[0] + '...' + data.realName[data.realName.length - 1]
          : data.realName;
      memberName == 'saleName'
        ? (this.saleStatus = this.getMemberStatus(data.status))
        : (this.healthyStatus = this.getMemberStatus(data.status));
    }
  });

  getMemberStatus = (status) => {
    switch (status) {
      case 0:
        return '有效';
      case 1:
        return '未激活';
      case 2:
        return '未续约';
      case 3:
        return '注销';
      case 4:
        return '冻结';
      case 5:
        return '休眠期';
      default:
        return '';
    }
  };

  /**
   * 获取注册时所填写的健康顾问信息
   */
  getHealthyUser = flow(function* () {
    if (!!this.healthy) return;
    const { data, resultCode } = yield Serv.getHealthyUser();
    // 存在注册时填写的健康顾问，将其显示并不可编辑
    if (resultCode == '0' && data && data.healthConsultantNum) {
      this.healthy = data.healthConsultantNum;
      this.initHealthy = data.healthConsultantNum;
      this.sale = data.healthConsultantNum;
      this.getMemberName('healthyName', this.healthy);
      this.getMemberName('saleName', this.sale);
      this.getNationList(data.healthConsultantNum);
    }
  });

  /**
   * 民族校验
   */
  nationValidate = flow(function* () {
    try {
      const { resultCode } = yield Serv.nationValidate({
        healthConsultantNum: this.healthy,
        nation: this.nation
      });
      return resultCode;
    } catch (error) {}
  });

  /**
   * 提交开店信息
   */
  submitStoreMsg = flow(function* (obj) {
    const { phoneVal } = obj || {};
    try {
      // this.nationValidate()
      const { headBankList, headBankId } = this;
      let bankName = '';
      headBankList.some((_val) => {
        if (_val.value == headBankId) {
          bankName = _val.name;
        }
      });
      this.realName = Util.getStrictName(this.realName);
      if (!this.realName) return;
      console.log('phoneValphoneValphoneVal', phoneVal);
      const params = {
        userId: Stores.AppMod.userInfo.id,
        bankAccount: this.bankNum,
        bankName,
        birthday: this.birth,
        branchCode: this.branchBankId,
        educational: this.level,
        healthConsultantNum: this.healthy,
        identityType: this.certType,
        identityCard: this.certNum,
        job: this.job,
        realName: this.realName,
        saleConsultantNum: this.sale,
        sex: this.gender,
        cardCode: this.cardCode,
        password: rstr2b64(this.password),
        phone: phoneVal || this.phone
        // nationId: this.nation,
      };
      console.log(params, 'paramsparamsparams');
      if (this.nation || this.nation === 0) {
        params.nationId = this.nation;
        params.nation = this.nation;
      }
      yield Serv.submitStoreMsg(params);
      Util.setLocalCache(Config.localStorageKeys.member_applyStoreMsg, {
        registerCardReqDto: params,
        registerType: 0 // '0' 代表未注册会员开店
      });
      // 缓存填写的信息，以便下次同个手机号进来，无需再次填写
      Util.setLocalCache(Config.localStorageKeys.member_cardFillMsg, {
        phone: this.phone,
        businessAddress: this.businessAddress,
        businessName: this.businessName,
        detailAddress: this.detailAddress,
        password: this.password,
        sale: this.sale,
        realName: this.realName,
        certType: this.certType,
        certNum: this.certNum,
        birth: this.birth,
        gender: this.gender,
        level: this.level,
        job: this.job,
        nation: this.nation,
        bankAddress: this.bankAddress,
        headBankId: this.headBankId,
        branchBankId: this.branchBankId,
        branchBankName: this.branchBankName,
        bankNum: this.bankNum
      });
      const pageConfig = {
        pathname: '/register/studioMsg',
        clear: true
      };

      if (this.storeTypeId) {
        pageConfig.state = {
          storeTypeId: this.storeTypeId, //进入选择店铺页面，店铺默认选中，显示区域代理地址Select框
          storeTypeName: this.storeTypeName,
          noChange: true,
          agentProvinceCode: this.agentProvinceCode,
          agentProvinceName: this.agentProvinceName,
          agentCityCode: this.agentCityCode,
          agentCityName: this.agentCityName,
          agentCountyCode: this.agentCountyCode,
          agentCountyName: this.agentCountyName
        };
      }

      window.app.routerGoTo(pageConfig);
    } catch (error) {}
  });

  // 更新健康顾问
  submitStoreUpdateHealthnum = flow(function* (data) {
    try {
      let params = {
        healthNum: data
      };
      const result = yield Serv.submitStoreUpdateHealthnum(params);
      return result;
    } catch (error) {}
  });

  /**
   * 按钮是否不可以点击
   */
  @computed
  get disabled() {
    const disabled_1 = !(
      `${this.healthy}` &&
      `${this.sale}` &&
      `${this.realName}` &&
      `${this.certType}` &&
      `${this.certNum}` &&
      `${this.level}` &&
      `${this.job}` &&
      `${this.bankAddress}` &&
      (this.headBankId || this.headBankId == 0) &&
      `${this.branchBankId}` &&
      `${this.bankNum}` &&
      `${(Stores.AppMod.internationalConfig || {}).hideNation ? true : this.nation}`
    );
    const disabled_2 = this.certType != 1 && !(this.birth && this.gender);
    return disabled_1 || disabled_2;
  }
}
const storeCardMsgMod = new StoreCardMsgMod();
export default storeCardMsgMod;



// WEBPACK FOOTER //
// ./src/pages/Register/StoreCardMsg/StoreCardMsgMod.js